const inflation = 0.02; // 2%
const portfolioRate = 0.05; // 5%
const savingsRate = 0.0125; // 1.25%

export function getResults({ initialInvestment, sliderValue }) {
    const years = sliderValue * 10;
    const goods = {
        milk: 5.38,
        eggs: 4.7,
        bread: 3.55,
        cappuccino: 2.57,
        transit: 2.6,
        movie: 12.57,
        cart: initialInvestment
    };

    let inflatedGoods = {};

    for (const good in goods) {
        inflatedGoods[good] = goods[good] * (1 + inflation) ** years;
    }

    const portfolioReturn = initialInvestment * (1 + portfolioRate) ** years;
    const savingsReturn = initialInvestment * (1 + savingsRate) ** years;

    const investmentReturn = {
        initialInvestment: initialInvestment,
        portfolio: portfolioReturn,
        savings: savingsReturn,
        portfolioAheadOfInflation: portfolioReturn - inflatedGoods.cart,
        savingsAheadOfInflation: savingsReturn - inflatedGoods.cart,
        cart: inflatedGoods.cart,
        portfolioRate: portfolioRate,
        savingsRate: savingsRate,
    };

    return {
        inflatedGoods: inflatedGoods,
        investmentReturn: investmentReturn,
    };
}

export function getBasketResults(startingAmount, timePeriod) {
    const inflatedCart = startingAmount * (1 + inflation) ** timePeriod;
    return inflatedCart;
}
